import { useParams, Redirect } from "react-router-dom";
import Package1 from "./Package1.js";
import Package2 from "./Package2.js";

const Preconfigured = () => {
    const params = useParams();
    const id = Number(params.id);
    const backToLabel = "Wooden Hot Tub";

    if (id === 1) return <Package1 backToLabel={backToLabel} />;

    if (id === 2) return <Package2 backToLabel={backToLabel} />;

    return <Redirect to="/" />;
};

export default Preconfigured;
